import React, { useState } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Password } from "primereact/password";
import { Link, Navigate, resolvePath } from "react-router-dom";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";

export default function Login(props) {
    const [nationalId, setNationalId] = useState("");
    const [password, setPassword] = useState("");
    const [redirectUrl, setRedirectUrl] = useState("");
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [saving, setSaving] = useState(false);

    const onInputChange = function(e, name){
        var val = '';
        val = (e.target && e.target.value) || '';
        if(name === "nationalId") setNationalId(val);
        else if(name === "password") setPassword(val);
    }
    const checkDataEntry = function(){
        if(nationalId.trim().length == 0){
            setErrorMessage("کد ملی را وارد کنید");
            setErorVisible(true);
            return false;
        }
        if(password.length == 0){
            setErrorMessage("کلمه عبور را وارد کنید");
            setErorVisible(true);
            return false;
        }
        return true;
    }
    const saveItem = function(){
        if(!checkDataEntry()) return;
        setSaving(true);
        var params = {nationalId:nationalId, password:password};
        var url = config.Server+`/user/login`;
        console.log("params is>", params);
        console.log("url is>", url);
        axios
            .post(url, params )
            .then(res => {
                var response = res.data;
                if(response.state === "ok"){
                    response = response.data;
                    console.log("response is>", response);
                    //return;
                    var SelectableRoles = [];
                    var roleId= 0;
                    var roleTitle = "";
                    var schoolId = "";
                    var schoolTitle = "";
                    var studentId = "";
                    var studentNationalId = "";
                    var studentFirstname = "";
                    var studentLastname = "";
                    if(response.roles){
                        SelectableRoles = response.roles;
                        if(response.roles.length == 1){                            
                            roleId = SelectableRoles[0].role.id;
                            roleTitle = SelectableRoles[0].role.title;
                            if(SelectableRoles[0].school != null){
                                schoolId = SelectableRoles[0].school.id;
                                schoolTitle = SelectableRoles[0].school.title;
                            }
                            if(SelectableRoles[0].student != null){
                                studentId = SelectableRoles[0].student.id;
                                studentNationalId = SelectableRoles[0].student.nationalId;
                                studentFirstname = SelectableRoles[0].student.firstname;
                                studentLastname = SelectableRoles[0].student.lastname;
                            }
                        }
                    }
                    var ExpireTime = new Date().getTime() / 1000;
                    ExpireTime += (15 * 60 * 1000);
                    var acc = {
                        UserId:response.user.id, 
                        Mobile:response.user.mobile, 
                        Firstname:response.user.firstname, 
                        Lastname:response.user.lastname, 
                        agentCode:response.user.agentCode,
                        Token:response.token,
                        NationalId:response.user.nationalId,
                        Role : roleId,
                        RoleTitle : roleTitle,
                        SelectableRoles:SelectableRoles,
                        ExpireTime : ExpireTime,
                        SchoolId : schoolId,
                        SchoolTitle : schoolTitle,
                        StudentId : studentId,
                        StudentNationalId : studentNationalId,
                        StudentFirstname : studentFirstname,
                        StudentLastname : studentLastname,
                    };
                    util.setCurrentUser(acc);
                    
                    var redirect = "/select-role";
                    if(SelectableRoles.length == 1){
                        redirect = "/home"
                    }
                    setRedirectUrl(redirect);
                    setSaving(false);
                    if(SelectableRoles.length <= 1){
                        props.onAccountChanged();
                        var newurl = config.Client + redirect
                        window.history.pushState({path:newurl},'',newurl);
                    }
                }
                else{
                    setErrorMessage(response.message);
                    setErorVisible(true);
                    setSaving(false);
                }
            })
            .catch(error => {
                setErrorMessage(error.code + "," + error.message);
                setErorVisible(true);
                setSaving(false);
            });
    }
    return(
        (redirectUrl != "")
        ?
        <Navigate to={redirectUrl} replace={false}  />
        :
        <>
        <div style={{width:"100%", boxSizing:"border-box", padding:"20px"}}>
            <table style={{width:"100%", minWidth:"250px", maxWidth:"350px", marginLeft:"auto", marginRight:"auto"}}>
                <tbody>
                    <tr>
                        <td style={{width:"100%", textAlign:"center"}}>
                            <img src={require('../lib/images/classico7-logo.png')} style={{width:"64px"}} />
                            {/* <span style={{fontSize:"4em", textAlign:"center"}} className="pi pi-user"></span> */}
                        </td>
                    </tr>
                    <tr>
                        <td style={{fontSize:"1.5em", textAlign:"center"}}>ورود به داشبورد کلاسیکو7</td>
                    </tr>
                    <tr><td>&nbsp;</td></tr>
                    <tr>
                        <td style={{fontSize:"1.5em", textAlign:"center", direction:"ltr"}}>
                            <FloatLabel>
                                <InputText value={nationalId} onChange={(e)=>{onInputChange(e, "nationalId")}} id="nationalId" keyfilter="int" maxLength={12} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />
                                <label htmlFor="username">کد ملی</label>
                            </FloatLabel>
                            
                        </td>
                    </tr>
                    <tr><td>&nbsp;</td></tr>
                    <tr>
                        <td style={{fontSize:"1.5em", textAlign:"center", direction:"ltr"}}>
                            <FloatLabel>
                                <Password value={password} onChange={(e)=>{onInputChange(e, "password")}} id="password" maxLength={30} className="p-inputtext-lg" pt={{
                                                iconField: {
                                                    root: {
                                                    style: { width: "100%" },
                                                    },
                                                },
                                                input: {
                                                    style: { width: "100%", textAlign:"center" },
                                                },
                                                root: {
                                                    style: { width: "100%" },
                                                },
                                                }} toggleMask feedback={false} />
                                <label htmlFor="password">کلمه عبور</label>
                            </FloatLabel>
                            
                        </td>
                    </tr>
                    <tr><td>&nbsp;</td></tr>
                    <tr>
                        <td style={{textAlign:"right"}}>
                        <React.Fragment>
                            <div className="card flex justify-content-center" style={{ direction: "ltr" }}>
                                <Button label="ورود به داشبورد" icon="pi pi-check" onClick={()=>saveItem()} loading={saving} severity="success" iconPos="right" />
                            </div>
                        </React.Fragment>

                        </td>
                    </tr>
                </tbody>
            </table>
            <br />
            <div style={{textAlign:"center", direction:"rtl"}}>
                <Link to="/reset-password" style={{textDecoration:"none", color:"#a0a0a0"}}>کلمه عبور را فراموش کرده ام</Link>
                
                {/* <Link to="/public/request-membership" style={{textDecoration:"none", color:"#a0a0a0"}}>درخواست عضویت معلم</Link> */}
            </div>
            <div style={{textAlign:"center", direction:"rtl", borderTop:"1px dotted #b0b0b0", marginTop:"20px", borderBottom:"1px dotted #b0b0b0"}}>
                تماس با ما: <label  style={{direction:"ltr"}}><a href="tel:09223455121">0922 345 5121</a></label>
                <br/>
                <a href="https://wa.me/9809223455121" target='_blank'><img src={require('../lib/images/whatsapp-icon.png')} style={{width:"48px", height:"48px", margin:"10px"}} /></a>
                <a href="https://t.me/classico7ir" target='_blank'><img src={require('../lib/images/telegram-icon.png')} style={{width:"48px", height:"48px", margin:"10px"}} /></a>
                <a href="https://www.instagram.com/@classico7ir" target='_blank'><img src={require('../lib/images/instagram-icon.png')} style={{width:"48px", height:"48px", margin:"10px"}} /></a>
            </div>
            <div style={{textAlign:"center", direction:"rtl", borderTop:"1px dotted #b0b0b0", marginTop:"20px", borderBottom:"1px dotted #b0b0b0", padding:"10px"}}>
                <Link to="/agent/request/membership" style={{textDecoration:"none", color:"#4862f7ff"}}>درخواست نمایندگی فروش</Link>
                &nbsp;-&nbsp;
                <Link to="/request-membership" style={{textDecoration:"none", color:"#4862f7ff"}}>درخواست عضویت مدرسه</Link>
            </div>
        </div>
        <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        </>
    );
}
